import "./contact-form.scss";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { navigate, Link } from "gatsby";

const ContactForm = ({ subject, selectedEmail, onReset }) => {
  const [formSubject, setFormSubject] = useState(subject ? `[${subject}]` : "");
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [send, setSend] = useState(false);
  const [legal, setLegal] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [recipient, setRecipient] = useState(selectedEmail);

  useEffect(() => {
    setRecipient(selectedEmail);
  }, [selectedEmail]);

  const resetForm = () => {
    setSend(false);
    setIsSending(false);
    setEmail("");
    setPhone("");
    setLegal(false);
    setMessage("");
    setFirstName("");
    setFormSubject("");
  };

  const formSubmit = (e) => {
    e.preventDefault();
    setSend(true);
    setIsSending(true);

    let formData = new FormData();

    formData.set("firstName", firstName);
    formData.set("email", email);
    formData.set("phone", phone);
    formData.set("subject", formSubject);
    formData.set("message", message);
    formData.set(
      "recipient",
      selectedEmail !== "" && selectedEmail !== undefined
        ? selectedEmail
        : "info@elcamp.pl"
    );

    axios({
      method: "post",
      url: "https://elcamp.com.pl/wp/wp-json/contact-form-7/v1/contact-forms/5/feedback/",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        console.log("Submit success");
        resetForm();
        navigate("/thank-you-page");
      })
      .catch((error) => {
        console.log("Submit error");
        console.log(error);
      });
  };

  return (
    <div className="contact-form">
      <h2 className="contact-form__title">Zadaj nam pytanie</h2>
      <div className="contact-form__subtitle">
        Skorzystaj z formularza kontaktowego <br /> (<span>*</span> pola
        wymagane)
      </div>
      <form onSubmit={formSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="input-group">
              <label htmlFor="firstName" className="input-group__label">
                Twoje imię
              </label>
              <input
                type="text"
                name="firstName"
                id="firstName"
                className="input-group__input"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="input-group">
              <label
                htmlFor="email"
                className="input-group__label input-group__label--required"
              >
                Twój adres email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                required
                className="input-group__input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="input-group">
              <label htmlFor="subject" className="input-group__label">
                Temat wiadomości (np. serwis, sprzedaż, części)
              </label>
              <input
                type="subject"
                name="subject"
                id="subject"
                className="input-group__input"
                value={formSubject}
                onChange={(e) => setFormSubject(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="input-group">
              <label htmlFor="phone" className="input-group__label">
                Twój numer telefonu
              </label>
              <input
                type="tel"
                name="phone"
                id="phone"
                className="input-group__input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="input-group">
              <label
                htmlFor="message"
                className="input-group__label input-group__label--required"
              >
                Wiadomość (opis sprawy)
              </label>
              <textarea
                name="message"
                id="message"
                className="input-group__textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
          </div>
          <div className="col-12">
            {recipient !== "" && recipient !== undefined ? (
              <div className="contact-form__send-to-text">
                Wysyłasz formularz do {selectedEmail}. Kliknij{" "}
                <span onClick={onReset}>TUTAJ</span> jeśli chcesz zrezygnować z
                wysyłki do danej osoby i wysłać formularz na info@elcamp.pl
              </div>
            ) : (
              ""
            )}
            <label
              className="checkbox-wrapper-newsletter"
              htmlFor="acceptance1"
            >
              <input
                type="checkbox"
                name="acceptance1"
                id="acceptance1"
                onChange={(e) => setLegal(!legal)}
              />
              <span>
                Wyrażam dobrowolną zgodę na przetwarzanie moich danych osobowych
                przez Elcamp RV sp. z.o.o. z siedzibą w Krakowie, ul. Tyniecka
                118E, 30-376 Kraków, KRS: 0000965816 (Administrator danych), w
                celu marketingu bezpośredniego dotyczącego własnych produktów i
                usług. Obowiązek informacyjny zgodnie z art. 13 ogólnego
                rozporządzenia o ochronie danych osobowych (RODO) z dnia 27
                kwietnia 2016 r. (Dz. Urz. UE L 119 z 04.05.2016): informacje o
                przetwarzaniu przez nas danych, jak również o prawach osób,
                których dane dotyczą znajdują się w naszej{" "}
                <Link to="/ogolne-warunki-sprzedazy-i-gwarancji#polityka-prywatnosci">
                  Polityce Prywatności
                </Link>
                *
              </span>
            </label>
            <div className="center-element">
              <button
                type="submit"
                className="btn contact-form__button"
                disabled={!legal && "disabled"}
              >
                {isSending ? "Wysyłanie..." : "Wyślij"}
              </button>
            </div>
            <div className="contact-form__bottom-info">
              Postaramy się odpowiedzieć jak najszybciej (1-2 dni robocze).
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
